<template>
    <!-- eslint-disable-next-line vue/no-v-html - sanitized in computed processed -->
    <span v-if="props.inline" class="fs-mask" data-marked data-marked-inline v-html="processed" />
    <!-- eslint-disable-next-line vue/no-v-html - sanitized in computed processed -->
    <div v-else class="fs-mask" data-marked v-html="processed" />
</template>

<script setup lang="ts">
import { marked, type RendererExtensionFunction } from "marked";
import { computed } from "vue";

import { noImageRenderer, sanitizeForChat } from "./utils/markdown";

type MarkdownTextProps = {
    text: string;
    customRenderer?: Record<string, RendererExtensionFunction>;
    inline?: boolean;
};

const props = withDefaults(defineProps<MarkdownTextProps>(), {
    inline: false,
});

const processed = computed(() => {
    const renderers: Record<string, RendererExtensionFunction> = { ...noImageRenderer };
    renderers.link = function (props) {
        const { href, text } = props;
        if (href.startsWith("mailto:")) {
            return `<a href="${href}" style="color: inherit; text-decoration: underline;">${text}</a>`;
        }
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`;
    };

    if (props.customRenderer) {
        Object.keys(props.customRenderer).forEach((key) => {
            if (key === "image") {
                return;
            }
            if (props.customRenderer?.[key]) {
                renderers[key] = props.customRenderer[key];
            }
        });
    }

    const options = { extensions: { renderers, childTokens: {} } };
    const rendered = props.inline ? marked.parseInline(props.text, options) : marked.parse(props.text, options);

    return sanitizeForChat(rendered);
});
</script>
